module.exports = {"projectName":"Project name","unit":"metric","language":"en","savings":"kWh","door":{"properties":{"height":2,"width":2,"numberOfWindowPanel":0,"openingFrequency":1095,"locationZone":{"country":"Germany","region":"Berlin","climateZoneClass":"Dfb"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/json/state/aaec-state.json
// module id = 37
// module chunks = 0